import React from "react";

const ArrowIcon = ({ width, height, color }) => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.0834 2.91669L16.0417 18.9584"
        stroke="#181818"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0834 2.91669L21.8751 32.0833L16.0417 18.9584L2.91675 13.125L32.0834 2.91669Z"
        stroke="#181818"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowIcon;
